import { render, staticRenderFns } from "./XFilterBox.vue?vue&type=template&id=e4ead6d6"
import script from "./XFilterBox.vue?vue&type=script&lang=js"
export * from "./XFilterBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports